<template>
  <div>
    <router-view></router-view>
    <simplert class="simplert" ref="simplert" />
    <!--    <simplert2 :use-icon="false" class="simplert" ref="alertTest" />-->
    <e-spinner :loading="$store.state.LoadingStatus" />
    <!-- [LOCAL] 로그아웃까지 남은시간 표시 (LOCAL 모드 전용, 추후 제거) -->
    <div v-if="isLocalMode && $store.getters['auth/jwt']"
         style="position:fixed;right:10px;bottom:10px;z-index:999999;background:rgba(0,0,0,.75);color:#0f0;font:13px/1.4 monospace;padding:6px 10px;border-radius:4px;pointer-events:none;"
    >
      로그아웃까지 {{ remainText }}
    </div>
  </div>
</template>

<style>
.simplert {
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.15
}
.simplert *,
.simplert :after,
.simplert :before {
  box-sizing: inherit
}

.simplert {
  position: fixed;
  z-index: 11111;
  top: 0;
  left: 0;
  display: none;
  overflow: auto;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #000;
  background-color: rgba(0, 0, 0, .4)
}

.simplert--shown {
  display: flex;
  align-items: center
}

.simplert--shown .simplert__content {
  animation-name: zoomIn;
  animation-duration: .3s;
  animation-fill-mode: both
}

.simplert__x { cursor: pointer; position:absolute; top:18px; right:20px; z-index:10009; width:22px; height:22px; border:0; background:url(./assets/images/common/icon_popclose.png) no-repeat 0 0; text-indent:-9999px; }

.simplert__header {
}

.simplert__title {
  margin-top: 15px !important;
  text-align: center !important;
  color: #075BB9 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.simplert__content {   width:330px;
  height:265px; position:relative; overflow:auto; margin:0 auto 0; padding:20px 20px 5px 20px; border-radius:5px; background:#ffffff; box-shadow: 0px 2px 1px 0 rgba(0, 0, 0, 0.4); }
.simplert__bg_white { background:#ffffff; }

.simplert__content--radius {
  -webkit-border-radius: .5rem;
  -moz-border-radius: .5rem;
  border-radius: .5rem
}

.simplert__body {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  margin-top: 15px !important;
  text-align: center !important;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  color: #000;
}
.simplert__icon {
  /*display:block;*/
  margin:30px auto 0;
  width: 60px;
  height: 60px;
  background-color: #E1EDFF;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border-radius: 50%;
}
.simplert__icon--success { background-image: url(./assets/images/common/icon_notice.png); }
.simplert__icon--notice { background-image: url(./assets/images/common/icon_notice.png); }
.simplert__icon--info{ background-image: url(./assets/images/common/icon_check.png); }

/*.simplert__icon {*/
/*  position: relative;*/
/*  width: 80px;*/
/*  height: 80px;*/
/*  margin: 10px auto;*/
/*  -webkit-border-radius: 50%;*/
/*  -moz-border-radius: 50%;*/
/*  border-radius: 50%*/
/*}*/

/*.simplert__icon--info {*/
/*  border: 4px solid #1a72ff*/
/*}*/

/*.simplert__icon--success {*/
/*  border: 4px solid #58c184*/
/*}*/

.simplert__icon--warning {
  border: 4px solid #fd821b
}

.simplert__icon--error {
  border: 4px solid #dd3b4b
}

.simplert__icon img {
  width: 80px;
  height: 80px
}

.simplert__line {
  position: absolute;
  z-index: 2;
  display: block;
  height: 5px;
  border-radius: 2px
}

.simplert__line--warning {
  position: absolute;
  top: 10px;
  left: 50%;
  width: 5px;
  height: 35px;
  margin-left: -2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  background-color: #fd821b
}

.simplert__line--warning-2 {
  position: absolute;
  bottom: 10px;
  left: 50%;
  width: 7px;
  height: 7px;
  margin-left: -3px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background-color: #fd821b
}

.simplert__line--error {
  top: 35px;
  left: 13px;
  width: 47px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #dd3b4b
}

.simplert__line--error-2 {
  top: 35px;
  right: 13px;
  width: 47px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #dd3b4b
}

.simplert__footer {
  padding: 1em 0
}

.simplert__close,
.simplert__confirm {
  display: inline-block;
  line-height: 1.2;
  outline: 0;
  font-weight: 700;
  margin: 0 .5em;
  border-radius: .25rem;
  height: 2.5rem;
  min-width: 2.5rem;
  font-size: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: #1a72ff;
  color: #fff;
  cursor: pointer;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none
}

.simplert__close:focus,
.simplert__confirm:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgb(66 153 225 / 60%)
}

.simplert__close--radius,
.simplert__confirm--radius {
  -webkit-border-radius: .3em;
  -moz-border-radius: .3em;
  border-radius: .3em
}

@keyframes zoomIn {
  from {
    transform: scale3d(.3, .3, .3);
    opacity: 0
  }
  50% {
    opacity: 1
  }
}
</style>

<script>
import ESpinner from '@/components/common/ESpinner'
import store from '@/store'
import { isRefreshExpired, isAccessExpiring, ensureFreshAccess } from '@/api/axios-ekmtc'

export default {
  name: 'App',
  components: {
    ESpinner
  },
  data () {
    return {
      activityThrottleTs: 0,
      remainSec: 0 // [LOCAL] 남은시간(초)
    }
  },
  computed: {
    serviceLang () {
      return store.getters['auth/serviceLang']
    },
    showLogin () {
      return this.$store.getters['auth/requireLogin']
    },
    remainText () { // [LOCAL] 남은시간 mm:ss
      const s = Math.max(0, this.remainSec)
      return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
    },
    isLocalMode () { // [LOCAL] LOCAL 모드에서만 남은시간 표시
      return process.env.VUE_APP_MODE === 'LOCAL'
    }
  },
  watch: {
    serviceLang: function () {
      this.setLocale()
    },
    showLogin: function () {
      this.checkAuth()
    }
  },
  created () {
    this.setLocale()
  },
  mounted () {
    // 탭 공유 유휴 타이머: 값이 없을 때만 초기화 — 리로드(탭 디스카드 부활, 절전 복귀 등)가
    // 잠들어 있던 유휴 시간을 지워 로그아웃을 무산시키지 않도록 기존 기록을 보존
    if (!localStorage.getItem('lastActivityTime')) {
      localStorage.setItem('lastActivityTime', String(Date.now()))
    }
    this.activityEvents = ['click', 'keydown', 'mousemove', 'scroll']
    this.activityEvents.forEach(e => globalThis.addEventListener(e, this.recordActivity, { passive: true }))
    this.authTimer = setInterval(this.checkAuth, 1000)

    // 부팅 시 stale 세션 정리 + 백그라운드/절전 복귀 시 선제 재검증
    // (백그라운드에선 타이머가 멈춰 만료 토큰이 남을 수 있음 → 복귀 시점에 만회)
    this.onResume()
    document.addEventListener('visibilitychange', this.onVisibilityResume)
    globalThis.addEventListener('focus', this.onResume)
  },
  beforeDestroy () {
    this.activityEvents.forEach(e => globalThis.removeEventListener(e, this.recordActivity))
    clearInterval(this.authTimer)
    document.removeEventListener('visibilitychange', this.onVisibilityResume)
    globalThis.removeEventListener('focus', this.onResume)
  },
  methods: {
    setLocale () {
      console.log('@@@@@@@ lang ', this.serviceLang)
      if (this.serviceLang === 'KOR') {
        this.$i18n.locale = 'ko-KR'
      } else if (this.serviceLang === 'ENG') {
        this.$i18n.locale = 'en-US'
      } else if (this.serviceLang === 'JPN') {
        this.$i18n.locale = 'ja-JP'
      } else if (this.serviceLang === 'CHN') {
        this.$i18n.locale = 'zh-CN'
      } else {
        this.$i18n.locale = 'ko-KR'
      }
    },
    onVisibilityResume () {
      if (document.visibilityState === 'visible') {
        this.onResume()
      }
    },
    onResume () {
      const token = sessionStorage.getItem('access_token')
      const refresh = sessionStorage.getItem('refresh_token')
      if (!token || !refresh) return

      // refresh 자체가 만료 → 서버로 보내지 않고(INVALID_TOKEN 로그·재사용 오탐 방지) 로컬만 조용히 정리.
      // quiet: logoutTime 을 기록하지 않아 다른 정상 탭을 로그아웃시키지 않음 → 메인에서 B-1 동기화로 세션 인계 가능
      if (isRefreshExpired(refresh)) {
        this.$store.dispatch('auth/delLoginInfo', { quiet: true })
        location.replace('/')
        return
      }

      // access 만료/임박이면 첫 요청 전에 미리 재발급 (실패 처리는 performRefresh 의 forceLogout 이 담당)
      if (isAccessExpiring(token)) {
        ensureFreshAccess().catch(() => {})
      }
    },
    recordActivity () {
      const now = Date.now()
      if (now - this.activityThrottleTs < 1000) return // 1초 throttle (mousemove 등 과다 호출 방지)
      this.activityThrottleTs = now

      // 이미 유휴 초과 상태면 리셋하지 않음 — 절전 복귀 직후의 마우스 움직임이
      // 로그아웃(checkAuth)을 무산시키는 것 방지. (비로그인 상태는 정상 리셋)
      const timeoutMs = (process.env.VUE_APP_AUTH_TIMEOUT ?? 60) * 60 * 1000
      const last = Number(localStorage.getItem('lastActivityTime')) || 0
      if (this.$store.getters['auth/jwt'] && last && now - last >= timeoutMs) return

      localStorage.setItem('lastActivityTime', String(now)) // 모든 탭 공유 (어느 탭 활동이든 세션 유지)
    },
    checkAuth () {
      const timeout = process.env.VUE_APP_AUTH_TIMEOUT ?? 60 // minutes (720 = 12h)
      const jwt = this.$store.getters['auth/jwt']
      if (!jwt) {
        this.remainSec = 0
        return
      }

      // 멀티탭: 다른 탭 로그아웃(delSessionStorage) 이벤트를 놓친 탭(리로드 중·탭 디스카드 후 부활 등)도
      // 상태(logoutTime > loginTime) 기반으로 1초 내 스스로 정리하는 안전망
      const loginTime = Number(localStorage.getItem('loginTime')) || 0
      const logoutTime = Number(localStorage.getItem('logoutTime')) || 0
      if (logoutTime > loginTime) {
        this.$store.dispatch('auth/delLoginInfo')
        globalThis.location.href = '/'
        return
      }

      const last = Number(localStorage.getItem('lastActivityTime')) || Date.now()
      const idleSec = (Date.now() - last) / 1000
      this.remainSec = Math.max(0, Math.floor(timeout * 60 - idleSec)) // [LOCAL] 에서만 사용

      if (idleSec >= timeout * 60) {
        this.$store.dispatch('auth/delLogin') // /logout 호출 + '/'(메인) 이동
      }
    }
  }
}
</script>
